/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Settings_Danger_ZoneInputs */



/**
* | output |
* | --- |
* | "Danger Zone" |
*
* @param {Project_Settings_Danger_ZoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_settings_danger_zone = /** @type {((inputs?: Project_Settings_Danger_ZoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Settings_Danger_ZoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gefahrenzone")
	return /** @type {LocalizedString} */ ("Danger Zone")
});